import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import url from "../../Url";
import { Link } from "react-router-dom";
import { getSlugForUrl } from "../../utils/urlCompatibility";

function Brand() {
  // Api for brand logos
  const [Brand, setBrand] = useState([]);
  useEffect(() => {
    axios
      .get(`${url}/api/brand/getAll`)
      .then((response) => {
        const sortedBrands = response.data.sort((a, b) => {
          const nameA = a.brand_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.brand_name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1; //nameA comes first
          }
          if (nameA > nameB) {
            return 1; // nameB comes first
          }
          return 0;  // names must be equal
        });
        setBrand(sortedBrands);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <div>
      <Helmet>
        {/* Basic SEO Tags */}
        <title>Flooring Brands | Squarefoot Flooring</title>
        <meta name="description" content="Discover premium flooring brands including hardwood, laminate, vinyl, and tile flooring. Quality products from trusted manufacturers at competitive prices." />
        <link rel="canonical" href={`${url}/brands`} />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Flooring Brands | Squarefoot Flooring" />
        <meta property="og:description" content="Discover premium flooring brands including hardwood, laminate, vinyl, and tile flooring. Quality products from trusted manufacturers at competitive prices." />
        <meta property="og:image" content={`${url}/android-chrome-512x512.png`} />
        <meta property="og:url" content={`${url}/brands`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Squarefoot Flooring" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Flooring Brands | Squarefoot Flooring" />
        <meta name="twitter:description" content="Discover premium flooring brands including hardwood, laminate, vinyl, and tile flooring. Quality products from trusted manufacturers at competitive prices." />
        <meta name="twitter:image" content={`${url}/android-chrome-512x512.png`} />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="Squarefoot Flooring" />
        <meta name="keywords" content="flooring brands, hardwood flooring brands, laminate flooring brands, vinyl flooring brands, tile brands, home improvement" />
        
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Flooring Brands | Squarefoot Flooring",
            "description": "Discover premium flooring brands including hardwood, laminate, vinyl, and tile flooring. Quality products from trusted manufacturers at competitive prices.",
            "url": `${url}/brands`,
            "mainEntity": {
              "@type": "ItemList",
              "name": "Flooring Brands",
              "description": "Premium flooring brands available at Squarefoot Flooring",
              "numberOfItems": Brand.length,
              "itemListElement": Brand.slice(0, 10).map((brand, index) => ({
                "@type": "Organization",
                "position": index + 1,
                "name": brand.brand_name,
                "url": `${url}/brand/${brand.slug}`,
                "logo": brand.brandLogo
              }))
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": url
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Brands",
                  "item": `${url}/brands`
                }
              ]
            }
          })}
        </script>
      </Helmet>

      {/* ************************ breadcrumb ******************** */}
      <br />

      <div className="breadcrumb mb-0">
        <div className="container">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            {">"}
            <li>Brands</li>
          </ul>
        </div>
      </div>

      {/* ************************ brands *********************** */}

      <div className="brands py-4">
        <div className="container">
          <h1 className="mb-4 black-color">Brands We Carry</h1>
          <div className="row g-4">
            {Brand.map((brand) => {
              return (
                <div
                  key={brand._id}
                  className="col-4 col-md-2 d-flex justify-content-center"
                >
                  <Link to={`/brand/${brand.slug}`} className="w-100">
                    <div className="brand-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center" style={{height: "120px", width: "100%"}}>
                      <img 
                        src={brand.brandLogo} 
                        alt={brand.brand_name}
                        className="img-fluid"
                        style={{maxHeight: "80px", objectFit: "contain"}}
                      />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brand;
